function normalizeBotMatch(currentBot, incomingBot) {
  if (!currentBot || !incomingBot) return true;
  const cleanCurrent = `${currentBot}`.replace(/\D/g, '');
  const cleanIncoming = `${incomingBot}`.replace(/\D/g, '');
  if (!cleanCurrent || !cleanIncoming) return true;
  return (
    cleanCurrent === cleanIncoming ||
    (cleanCurrent.length >= 10 &&
      cleanIncoming.length >= 10 &&
      cleanCurrent.slice(-10) === cleanIncoming.slice(-10))
  );
}

export function normalizeQueueCountsFromSocket(data) {
  const userCounts = data?.user_counts || {};
  return {
    intervene: Number(userCounts.intervene) || 0,
    min_15: Number(userCounts.min_15) || 0,
    hrs_24: Number(userCounts.hrs_24) || 0,
    history: Number(userCounts.history) || 0,
    total: Number(userCounts.total) || 0,
  };
}

export function createHandleCountsUpdated({ setChatCounts, getBotNumber }) {
  return (data) => {
    const botNumber = getBotNumber();
    if (data?.bot_number && botNumber && !normalizeBotMatch(botNumber, data.bot_number)) {
      return;
    }
    setChatCounts(normalizeQueueCountsFromSocket(data));
  };
}
